<tabs>
  <tab-single
    *ngIf="showMainTab"
    [tabId]="tabIdList.KPI__BROSH"
    [link]="urlKpiBrosh"
    tabTitle="translate.kpi.brosh"
  ></tab-single>

  <tab-single
    *ngIf="showAgentsTab"
    [tabId]="tabIdList.KPI__AGENTS"
    [link]="urlKpiAgents"
    tabTitle="translate.kpi.agents"
  >
  </tab-single>

  <tab-single
    *ngIf="showClinicsTab"
    [tabId]="tabIdList.KPI__CLINICS"
    [link]="urlKpiClinics"
    [tabTitle]="clinicTabTitle"
  >
  </tab-single>
</tabs>
